import type { ReactNode } from 'react';
import { Button } from './button';

/**
 * A working state is a text swap in the same tracked caps — "Creating…",
 * "Keeping…" — never a spinner: a spinner is not in this system's vocabulary
 * (ui-design §5). Buttons disable while in flight for honesty, not safety;
 * identical answer replays are idempotent by contract.
 */
export function WorkingButton({
  label,
  workingLabel,
  working = false,
  disabled = false,
  onClick,
  variant = 'go',
  tiny = false,
  title,
}: {
  label: ReactNode;
  workingLabel: string;
  working?: boolean;
  disabled?: boolean;
  onClick: () => void;
  variant?: 'go' | 'act' | 'danger';
  tiny?: boolean;
  title?: string;
}) {
  return (
    <Button
      variant={variant}
      tiny={tiny}
      disabled={working || disabled}
      onClick={onClick}
      title={title}
    >
      {working ? workingLabel : label}
    </Button>
  );
}
